import { render, staticRenderFns } from "./LessonEditorEnhanced.vue?vue&type=template&id=2cab0131"
import script from "./LessonEditorEnhanced.vue?vue&type=script&lang=js"
export * from "./LessonEditorEnhanced.vue?vue&type=script&lang=js"
import style0 from "./LessonEditorEnhanced.vue?vue&type=style&index=0&id=2cab0131&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports